import httpClient from '../httpClient';

const searchDocument = async (data) => {
  return await httpClient.post(`/document_verification/`, data);
};

export { searchDocument };
